import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { CancelIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type CancelFormProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const CancelFormButton: React.FC<CancelFormProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore } = rootStore;

    return (
      <Button
        sx={{ color: "darkRed" }}
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<CancelIcon />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {!label ? "Cancelar" : label}
      </Button>
    );
  }
);
